(function (angular) {
    'use strict';
    angular.module('SMART2').directive('smartGlobalSearch', ['routeSvc', '$translate', '$rootScope','$timeout', '$state', 'globalSearchService', 'commonUtilities', 'APPCONSTANTS', smartGlobalSearchFunc]);
    function smartGlobalSearchFunc(routeSvc, $translate, $rootScope, $timeout, $state, globalSearchService, commonUtilities, APPCONSTANTS) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                onClose: "&",
                type: "@",
                searchClass: "@",
                fixButton: "@",
                moduleScope: "@",
                searchText: "=",
                pageName: "@",
                autosuggest: "@",
				config : '=',
                onSearch: "&?", disableRecentSearch: "@"
            },
            link: function (scope, element, attrs) {
				
				scope.fireEvent = false;
				scope.$on('setProjectfocus', function (e, args) {
					if(scope.type == 'scopeSearch' && scope.moduleScope == 'Partner' && $state.params && $state.params.pagefor=='project'){
						setTimeout(function(){
						$('.projectsTeamMemberHdrSearch input').focus();
						scope.autoComplete.showRecentSearches = false;
						scope.fireEvent = true;
						},10);
					} 
                });
                scope.isHome = false;
                scope.fixButton = scope.$eval(scope.fixButton);
                scope.pageName = scope.$eval(scope.pageName);
                scope.recentSearches = null;
                var disableRecentSearch = scope.disableRecentSearch;

                scope.autosuggest = (scope.autosuggest) ? scope.$eval(scope.autosuggest) : false;
                if (scope.type == "home") {
                    scope.isHome = true;
                }
                scope.autoComplete = { autoCompleteData: "", autoCompleteDropDown: "off", showRecentSearches: false };
                scope.isFocused = false;
                scope.isKeyPressed = false;
                scope.setFocus = function () {
                    scope.isFocused = true;
                }
                globalSearchService.shareFocus(scope.setFocus);
                commonUtilities.setDataMapper(setList);
                function setList(data) {
                    if (!scope.documentList || scope.documentList.length == 0) {
                        scope.documentList = globalSearchService.getDocumentList(data);
                    }
                }

                scope.onSearchTextFocus = function (e) {
                    if (scope.autoComplete.autoCompleteData.trim().length > 3 && scope.autosuggest) {
                        scope.autoComplete.showRecentSearches = false;
                        if (scope.isKeyPressed) {
                            scope.showAutoComplete = true;
                        }
                    }
                    else {
                        scope.autoComplete.showRecentSearches = true;
                        scope.showAutoComplete = false;
                        scope.autoComplete.autoCompleteDropDown = "off";
                        scope.options = [];
                        if (!disableRecentSearch) {
                            getRecentSearches();
                        }
                    }
                };
                scope.showAutoComplete = false;

                if (scope.searchText) {

                    scope.autoComplete.autoCompleteData = scope.searchText;
                    console.log(element);
                    element[0].focus();
                }

                scope.$watch('autoComplete.autoCompleteData', function (value) {
                    if (!scope.documentList) {
                        commonUtilities.setDataMapper(setList);
                    }
                    if (value && value.trim().length > 0) {
                        scope.isClear = true;
                        if (value.trim().length > 3) {
                            scope.autoComplete.showRecentSearches = false;
                            scope.showAutoComplete = true;
                        } else {
                            scope.autoComplete.showRecentSearches = false;
                            scope.showAutoComplete = false;
                        }
                    }
                    else {
                        scope.showAutoComplete = false;
                        scope.isClear = false;
                    }
                });

                scope.closeCallback = function () {
					scope.fireEvent = false;
                    if (scope.searchText) {
                    } else {
                        scope.autoComplete.autoCompleteData = "";
                    }

                    scope.isClear = false;
                    scope.onClose();
                }
                scope.onSelect = function (autoCompleteData) {
                    if (autoCompleteData.trim().length > 0)
                        saveAndRedirect(autoCompleteData);
                }

                //searchfield
                scope.searchField = function () {
                    scope.inputFocused = true;
                }

                scope.onkeyDown = function (autoCompleteData, e) {
                    scope.isKeyPressed = true;
                    if (e && e.keyCode == 13) {
                        $timeout(function () {
                            if (scope.autoComplete.autoCompleteData.trim().length > 0) {
                                scope.autoComplete.showRecentSearches = false;
                                scope.showAutoComplete = false;
                                saveAndRedirect(scope.autoComplete.autoCompleteData);
                            }
                        }, 1000);
                    }
                }
                scope.onRecentSearchItemClick = function (autoCompleteData, e) {
                    scope.autoComplete.autoCompleteData = autoCompleteData;
                    scope.autoComplete.showRecentSearches = false;
                    scope.showAutoComplete = false;
                    saveAndRedirect(autoCompleteData);
                }

                function clearSearchBar() {
                    if (scope.type == "sidenav") {
                        scope.autoComplete.autoCompleteData = '';
                    }
                }
				if(scope.config)
				{						
					scope.config.forFullFocusFromLandingpage = function()
					{
						scope.onSearchTextFocus();
					};
				}
                /*scope.saveAndRedirectSuggestion = function (autoCompleteData, doc) {
                    scope.isKeyPressed = false;
                    scope.showAutoComplete = false;
                    if (doc.url.indexOf("[searchData]") >= 0) {
                        doc.url = doc.url.split("[searchData]").join(autoCompleteData);
                    }
                    if (doc.url.indexOf('[bpc]') > -1)
                    {
                        doc.url = '/' + doc.url;
                        doc.url = doc.url.replace('[bpc]', APPCONSTANTS.userPreferences.EncryptedBPC.toString());
                    }
					if(doc && doc.name == 'catalog'){
						window.localStorage.setItem('catalogSearch',JSON.stringify(autoCompleteData));
                    }
                    if(doc && doc.name == 'project'){
                        if(APPCONSTANTS.userPreferences.ProjectsLandingPage)
                     doc.url =  APPCONSTANTS.userPreferences.URLs.WorkspaceBaseUrl + '#/landingmax?pagefor=search&scope=project&q=' + scope.autoComplete.autoCompleteData;
                     
                     }
                    routeSvc.goTo(doc.url);
                    saveRecentSearch(autoCompleteData);
                }*/


                scope.saveAndRedirectSuggestion = function (autoCompleteData, doc) {
                    scope.isKeyPressed = false;
                    scope.showAutoComplete = false;
                    if (doc.url.indexOf("[searchData]") >= 0) {
                        doc.url = doc.url.split("[searchData]").join(autoCompleteData);
                    }
                    if (doc.url.indexOf('[bpc]') > -1)
                    {
                        doc.url = '/' + doc.url;
                        doc.url = doc.url.replace('[bpc]', APPCONSTANTS.userPreferences.EncryptedBPC.toString());
                    }
                    if(doc && doc.name == 'catalog'){
                        routeSvc.goTo(doc.url);
                        //window.localStorage.setItem('catalogSearch',JSON.stringify(autoCompleteData));
                    }
                    if(doc && doc.name == 'project' && !APPCONSTANTS.userPreferences.ProjectsLandingPage){
                      routeSvc.goTo(doc.url);
                     //doc.url =  APPCONSTANTS.userPreferences.URLs.WorkspaceBaseUrl + '#/landingmax?pagefor=search&scope=project&q=' + scope.autoComplete.autoCompleteData;
                    }else if(doc && doc.name == 'report'){
                        
                         $rootScope.$broadcast('setSearchModel', { data: { searchname: (scope.autoComplete.autoCompleteData) ? scope.autoComplete.autoCompleteData.toString() : '' } });
                         routeSvc.stateTo('landingList', { "pagefor": 'search', 'q': scope.autoComplete.autoCompleteData.toString(), 'scope': doc.name });
                     
                    }else{
                         $rootScope.$broadcast('setSearchModel', { data: { searchname: (scope.autoComplete.autoCompleteData) ? scope.autoComplete.autoCompleteData.toString() : '' } });
                         routeSvc.stateTo('expandedlandinglist', { "pagefor": 'search', 'q': scope.autoComplete.autoCompleteData.toString(), 'scope': doc.name });
                    }
                    //routeSvc.goTo(doc.url);
                    saveRecentSearch(autoCompleteData);
                }

                function saveAndRedirect(autoCompleteData) {
                    saveRecentSearch(autoCompleteData);
                    if (scope.onSearch) {
                        scope.onSearch({ searchKeyword: scope.autoComplete.autoCompleteData });
                        return;
                    }
                    if (scope.type == "scopeSearch") {
                        var Pagefor = $state.params.pagefor;
                        if (Pagefor && Pagefor.toLowerCase() == "sourcing") {
                            routeSvc.stateTo('rfx.addSupplier', { "pagefor": "sourcing", 'q': scope.autoComplete.autoCompleteData, 'scope': scope.moduleScope });
                        }
                        else if (Pagefor && Pagefor.toLowerCase() == "scorecard") {
                            routeSvc.stateTo('addSupplier', { "pagefor": "scorecard", 'q': scope.autoComplete.autoCompleteData, 'scope': scope.moduleScope });
                        }
                        else if (Pagefor && Pagefor.toLowerCase() == "form") {
                            routeSvc.stateTo('addFormSupplier', { "pagefor": "form", 'q': scope.autoComplete.autoCompleteData, 'scope': scope.moduleScope });
                        }
                        else if (Pagefor && Pagefor.toLowerCase() == "project" &&  scope.moduleScope=="Partner") {
                            routeSvc.stateTo('addNewSupplier', { "pagefor": "project", 'q': scope.autoComplete.autoCompleteData, 'scope': scope.moduleScope });
                        }
                        else if (Pagefor && (Pagefor.toLowerCase() == "project" || Pagefor.toLowerCase() == "projectrequest" )&& (scope.moduleScope == "rfx" || scope.moduleScope == "auction" || scope.moduleScope == "contract" || scope.moduleScope == "order" || scope.moduleScope =="partners" || scope.moduleScope == "project")) {
                            if(Pagefor.toLowerCase() == "project" )
                                routeSvc.stateTo('linkDocument', { "pagefor": "project", 'q': scope.autoComplete.autoCompleteData, 'scope': scope.moduleScope });
                            else if (Pagefor.toLowerCase() == "projectrequest" && $state.params.psrc == "contractPrf" && $state.params.scope == "contract")
                                routeSvc.stateTo('linkContracttoPRF', { "pagefor": "projectrequest", 'q': scope.autoComplete.autoCompleteData, 'scope': scope.moduleScope, 'psrc': $state.params.psrc, 'sourceDT': $state.params.sourceDT });
                            else
                                routeSvc.stateTo('linkDocument', { "pagefor": "projectrequest", 'q': scope.autoComplete.autoCompleteData, 'scope': scope.moduleScope});
                        }
                        else {
                            if (scope.onClose)
                                scope.onClose();
                            routeSvc.stateTo('expandedlandinglist', { "pagefor": Pagefor.toLowerCase(), 'q': scope.autoComplete.autoCompleteData, 'scope': scope.moduleScope });
                        }
                    }
                    else {
						//var redirectionUrl = APPCONSTANTS.userPreferences.URLs.WorkspaceBaseUrl + '#/landingmax?pagefor=search&scope=all&q=' + scope.autoComplete.autoCompleteData;
                        
                        $rootScope.$broadcast('setGlobalSearchHeaderTrue', { data : { show: true,scopename : 'all' } });
                        //routeSvc.goTo(redirectionUrl);
						$rootScope.$broadcast('setSearchModel', { data: { searchname: (scope.autoComplete.autoCompleteData) ? scope.autoComplete.autoCompleteData.toString() : '' } });
                        //$state.go('searchResult', { search: scope.autoComplete.autoCompleteData });						
						if(APPCONSTANTS.userPreferences.NAVButtonsAccessRights.Manage["ManageDocs"] && (APPCONSTANTS.userPreferences.NAVButtonsAccessRights.Manage["ManageDocs"].report ==APPCONSTANTS.userPreferences.NAVButtonsAccessRights.Manage["ManageDocs"].TotalCount) && APPCONSTANTS.userPreferences.NAVButtonsAccessRights && APPCONSTANTS.userPreferences.NAVButtonsAccessRights.Create&& APPCONSTANTS.userPreferences.NAVButtonsAccessRights.Create.length == 1 && APPCONSTANTS.userPreferences.NAVButtonsAccessRights.Create.indexOf(-3) > -1 ){
							routeSvc.stateTo('landingList', { "pagefor": 'search', 'q': scope.autoComplete.autoCompleteData, 'scope': 'report' });
						}else{
							routeSvc.stateTo('expandedlandinglist', { "pagefor": 'search', 'q': scope.autoComplete.autoCompleteData.toString(), 'scope': 'all' });
						}
					}
                }

                function saveRecentSearch(autoCompleteData) {
                    var recentSearch = { "Sequence": 0, "SearchText": autoCompleteData.trim() };
                    if (!scope.recentSearches) {
                        scope.recentSearches = [];
                    }
                    var recentSearches = angular.copy(scope.recentSearches);
                    var objRecent = _.find(recentSearches, function (r) { return r.SearchText.toLowerCase() == autoCompleteData.toLowerCase().trim() });
                    if (!objRecent)
                    {
                        _.map(recentSearches, function (r, i) { r.Sequence = i + 1; return r });
                        recentSearches.unshift(recentSearch);
                    }else{
						var objIndex = _.indexOf(_.pluck(recentSearches, 'SearchText'), autoCompleteData);
                            recentSearches.splice(objIndex, 1);
                            _.map(recentSearches, function (r, i) { r.Sequence = i + 1; return r });
                            recentSearches.unshift(recentSearch);
					}
                    scope.recentSearches = recentSearches;
                    var recentData = {
                        "recentSearches": JSON.stringify(recentSearches),
                        "moduleType": 0,
                        "fieldKey": 0
                    }
                    clearSearchBar();
                    globalSearchService.saveRecentSearches(recentData, searchText, searchText);
                }

                function searchText() {

                }

                /* on load focus on search field */
                $timeout(callAtTimeout, 1000);
                function callAtTimeout() {
                    scope.focusSearch = true;
                }

                function getRecentSearches() {
                    if (scope.recentSearches) {
                        scope.recentSearches = scope.recentSearches.splice(0, 5);
                        scope.autoComplete.showRecentSearches = true;
                        return;
                    }
                    scope.recentSearches = null;
                    scope.isRecentSearchesLoading = true;
                    globalSearchService.getRecentSearches(bindRecentSearch, errorRecentSearch);
                };

                function bindRecentSearch(data) {
                    scope.autoComplete.showRecentSearches = (scope.fireEvent) ? false :  true;
                    scope.isRecentSearchesLoading = false;

                    if (data.RecentSearches) {
                        scope.recentSearches = JSON.parse(data.RecentSearches).splice(0, 5);
                    }
                    else {
                        scope.recentSearches = null;
                    }
                }

                function errorRecentSearch(data) {
                    scope.recentSearches = null;
                    scope.isRecentSearchesLoading = false;
                }

                var onDocumentClick = function () {
                    if (scope.autoComplete.showRecentSearches == true) {
                        $timeout(function () {
                            scope.autoComplete.showRecentSearches = false;
                            globalSearchService.abortRequest();
                        });
                    }
                    if (scope.showAutoComplete) {
                        $timeout(function () {
                            scope.showAutoComplete = false;
                        });
                    }
                };
                $(document).on('click', function (event) {
                    var isClickedElementChildOfPopup = element
                   .find(event.target)
                   .length > 0;
                    if (isClickedElementChildOfPopup)
                        return;
                    onDocumentClick();
                });

                scope.$on('$destroy', function () {
                    $(document).off('click', onDocumentClick);
                })
            },
            templateUrl: 'shared/directives/smartGlobalSearch/smartGlobalSearchTemplate.html'
        }
    };
})(angular);
